import { useNavigate } from "react-router-dom";

function AddCourtButton() {
    const navigate = useNavigate();
    return (
      <button
        className="add_new_court_button"
        onClick={() => navigate("/courts/add")}
      >
        Add a New Futsal Court
      </button>
    );
}

export default AddCourtButton;